import * as Surplus from 'surplus';
import { ReLoginPage } from './Login';
export const AppContainer = ({ app, children }) => (<div className="app">
        
        {app.requestCredentials()
    ? <ReLoginPage {...app}/>
    : children()}
    </div>);
